import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StepperComponent } from '@progress/kendo-angular-layout';
import { Message } from 'src/app/shared/models/domain';
import { Separation } from 'src/app/shared/models/separation';
import { CommonService } from 'src/app/shared/services/common.service';
import { CompanyService } from 'src/app/shared/services/company.service';
import { SeparationService } from 'src/app/shared/services/separation.service';
import { AccessRevocationComponent } from '../separation-wizard/access-revocation/access-revocation.component';
import { DocumentDownloadComponent } from '../separation-wizard/doucment-download/document-download.component';
import { ExitClearanceComponent } from '../separation-wizard/exit-clearance/exit-clearance.component';
import { ExitInterviewComponent } from '../separation-wizard/exit-interview/exit-interview.component';
import { FinalSettlementComponent } from '../separation-wizard/final-settlement/final-settlement.component';
import { SeparationComponent } from '../separation-wizard/separation/separation.component';
import { TerminationAppealComponent } from '../separation-wizard/termination-appeal/termination-appeal.component';
import { Context } from 'src/app/shared/models/context';
import { AuthService } from 'src/app/shared/services/auth.service';
@Component({
  selector: 'app-termination-wizard',
  templateUrl: './termination-wizard.component.html',
  styleUrls: ['./termination-wizard.component.scss']
})
export class TerminationWizardComponent implements OnInit {

  @ViewChild(SeparationComponent) separationComponent!: SeparationComponent;
  @ViewChild(TerminationAppealComponent) appeal!: TerminationAppealComponent;
  @ViewChild(ExitInterviewComponent) exit!: ExitInterviewComponent;
  @ViewChild(AccessRevocationComponent) access!: AccessRevocationComponent;
  @ViewChild(ExitClearanceComponent) clearance!: ExitClearanceComponent;
  @ViewChild(FinalSettlementComponent) settlement!: FinalSettlementComponent;
  @ViewChild(DocumentDownloadComponent) docDownload!: DocumentDownloadComponent;

  @ViewChild('stepper', { static: true })

  public stepper: StepperComponent;
  public isLoading: boolean = true;
  public currentStep = 0;
  public showSaveButton: boolean = false;
  public separationId: number;
  private sumbitted = false;
  public separationType: string = '';
  @Input() separation: Separation;
  @Input() context: Context;

  private shouldValidate = (): boolean => {
    return this.sumbitted === true;
  };

  public steps = [
    {
      label: 'Termination',
      validate: this.shouldValidate
    },
    {
      label: 'Employee Appeal',
      validate: this.shouldValidate
    },
    {
      label: 'Access Revocation',
      validate: this.shouldValidate
    },
    {
      label: 'Exit Clearance',
      validate: this.shouldValidate
    },
    {
      label: 'Final Settlement',
      validate: this.shouldValidate
    },
    {
      label: 'Document Download',
      validate: this.shouldValidate
    }
  ];

  public get filteredSteps() {
    return this.separationType === 'TERMINATION'
      ? this.steps.filter(step => step.label !== 'L-One Status' && step.label !== 'HR Status')
      : this.steps;
  }

  constructor(
    private separationService: SeparationService,
    private route: ActivatedRoute,
    private companyService: CompanyService,
    private commonService: CommonService,
    private router: Router,
    private authService: AuthService,
  ) { }

  ngOnInit() {
    this.initData();
    this.context = this.authService.getContextData();
    this.steps = this.context.persona === 'HR' ? this.steps : this.steps.slice(0, 2);
  }

  private initData() {
    this.route.queryParams.subscribe(params => {
      if (params['sId']) {
        this.separationId = Number(params['sId']);
        this.separationType = params['type'] || 'RESIGNATION';
      }
    });
  }

  private handleSeparationSave() {
    const saveSeparation$ = this.separationComponent.saveSeparation();
    if (saveSeparation$) {
      saveSeparation$.subscribe({
        next: (response: Message) => {
          if (!response.failed) {
            this.separationId = response.payload;
            this.commonService.setToastr(200, `Separation has been created successfully!`);
            this.router.navigate([], {
              queryParams: { sId: this.separationId },
              queryParamsHandling: 'merge'
            });
            this.separationComponent.getSeparation();
            this.currentStep += 1;
          } else {
            this.commonService.setToastr(500, response.text);
          }
        },
        error: (err) => {
          this.commonService.setToastr(500, `Failed to create separation: ${err.message}`);
        }
      });
    }
  }

  public next(): void {
    if (this.currentStep === 0) {
      if (!this.separationId) {
        this.handleSeparationSave();
      }
      if (this.separationId) {
        this.separationComponent.getSeparation();
        this.currentStep += 1;
      }
    }
    else if (this.currentStep === 1) {
      this.appeal.saveTerminationAppeal();
      this.appeal.getTerminationAppeal();
      if (this.context.persona === 'HR') {
        this.currentStep += 1;
      }
    }

    else if (this.currentStep === 2) {
      if (!this.access?.selectedAccessRevocation?.id) {
        const saveAccess$ = this.access.saveAccessRevocation();
        if (saveAccess$) {
          saveAccess$.subscribe(() => {
            this.access.getAccessRevocation();
            this.currentStep += 1;
          });
        }
      } else {
        this.access.getAccessRevocation();
        this.currentStep += 1;
      }
    }
    else if (this.currentStep === 3) {
      if (!this.clearance?.selectedClearance?.id) {
        const saveClearance$ = this.clearance.saveExitClearance();
        if (saveClearance$) {
          saveClearance$.subscribe(() => {
            this.clearance.getExitClearance();
            this.currentStep += 1;
          });
        }
      } else {
        this.clearance.getExitClearance();
        this.currentStep += 1;
      }
    }
    else if (this.currentStep === 4) {
      if (!this.settlement?.selectedSettlement?.id) {
        const saveSettlement$ = this.settlement.saveSettlement();
        if (saveSettlement$) {
          saveSettlement$.subscribe(() => {
            this.settlement.getFinalSettlement();
            if (this.settlement?.selectedSettlement?.id) {
              this.currentStep += 1;
            }
          });
        }
      } else {
        this.settlement.getFinalSettlement();
        if (this.settlement?.selectedSettlement?.id) {
          this.currentStep += 1;
        }
      }
    }
  }

  get saveOrNextButtonLabel() {
    if (this.currentStep === 0) {
      return !this.separationId ? 'Save' : 'Next';
    } else if (this.currentStep === 1) {
      return !this.appeal?.appeal?.id && this.context.persona ==='HR' ? 'Next' : 'Save';
    } else if (this.currentStep === 2) {
      return !this.access?.selectedAccessRevocation?.id ? 'Save' : 'Next';
    } else if (this.currentStep === 3) {
      return !this.clearance?.selectedClearance?.id ? 'Save' : 'Next';
    } else if (this.currentStep === 4) {
      return !this.settlement?.selectedSettlement?.id ? 'Save' : 'Next';
    }
  }

  public prev(): void {
    if (this.currentStep === 5) {
      this.currentStep -= 1;
      if (this.docDownload.documentDownloads?.[0]?.id) {
        this.docDownload.getDocumentDownloads();
      }
    }
    else if (this.currentStep === 4) {
      this.currentStep -= 1;
      if (this.settlement?.selectedSettlement?.id) {
        this.settlement.getFinalSettlement();
      }
    }
    // else if (this.currentStep === 4) {
    //   this.currentStep -= 1;
    //   if (this.clearance?.selectedClearance?.id) {
    //     this.clearance.getExitClearance();
    //   }
    // }
    else if (this.currentStep === 3) {
      this.currentStep -= 1;
      if (this.access?.selectedAccessRevocation?.id) {
        this.access.getAccessRevocation();
      }
    }
    else if (this.currentStep === 2) {
      this.currentStep -= 1;
      if (this.exit?.selectedexitInterview?.id) {
        this.exit.getExitInterview();
      }
    }
    else if (this.currentStep === 1) {
      this.currentStep -= 1;
      if (this.appeal?.appeal?.id) {
        this.appeal.getTerminationAppeal();
      }
    }
  }

}

